import React from 'react';

/** Badge de contexte : désactivé en prod (plus de filigrane / preview tierce). */
const DevBadge = () => null;

export default DevBadge;
